import "./usuariosweb.scss";
import React, { useState } from "react";
import TituloCard from "../../atoms/titles/Titulo";
import { Link } from "react-router-dom";
import NuevaAltaUsuario from "./nuevaAltaUsuario/NuevaAltaUsuario";
import ModNombrePasswd from "./modNombrePasswd/ModNombrePasswd";

const UsuariosWeb = () => {

  const [zona, setZona] = useState({
    links: true,
    
    nuevaAltaUsuario:false,
    modNombrePasswd:false
  })

  return (
    <>
      <TituloCard tipo="tituloModal" titulo={<h2 className="tituloPagina4">Usuarios Web</h2>} />
      <div className="">
      {zona.links ? (<>
        <div className="d-flex flex-column">
          <div
            onClick={() => {
              //TODO
            }}
          >
            <i className="fa-solid fa-caret-right my-2">
              <Link to={""} className="fw-light" onClick={() => { setZona({nuevaAltaUsuario:true }) }}>
                {" "}
                Nuevo Usuario
              </Link>
            </i>
          </div>
          <div
            className=""
            onClick={() => {
              //TODO
            }}
          >
            <i className="fa-solid fa-caret-right my-2" onClick={() => { setZona({modNombrePasswd:true }) }}>
              <Link to={""} className="fw-light">
                {" "}
                Modificar el nombre de usuario y/o su password
              </Link>
            </i>
          </div>
        </div>
      </>) : null}
      {zona?.nuevaAltaUsuario ? (<><NuevaAltaUsuario setZona={setZona}/></>) : null}
      {zona?.modNombrePasswd ? (<><ModNombrePasswd setZona={setZona}/></>) : null} 
      </div>
    </>
  );
};
export default UsuariosWeb;
